



















import { Vue, Component } from "vue-property-decorator";
import { Observer } from "mobx-vue";
import userStore from "@/store/userStore";

@Observer
@Component
export default class SelectCouncil extends Vue {
  userStore = userStore;

  async selectCouncil(councilName: string) {
    await userStore.setActiveCouncil(councilName);
    this.$router.push({ name: "Home" });
  }
}
